// src/components/Presentation/SpeakerNotes.js
import React, { useState, useRef, useEffect } from 'react';
import { Type, Maximize2, Minimize2 } from 'lucide-react';

const SpeakerNotes = ({ notes, onUpdate, placeholder }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [localNotes, setLocalNotes] = useState(notes);
  const textareaRef = useRef(null);

  useEffect(() => {
    setLocalNotes(notes);
  }, [notes]);

  const handleNotesChange = (value) => {
    setLocalNotes(value);
    onUpdate(value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Tab') {
      e.preventDefault();
      const start = e.target.selectionStart;
      const end = e.target.selectionEnd;
      const value = e.target.value;
      const newValue = value.substring(0, start) + '  ' + value.substring(end);
      setLocalNotes(newValue);
      onUpdate(newValue);
      
      // Reset cursor position
      setTimeout(() => {
        e.target.selectionStart = e.target.selectionEnd = start + 2;
      }, 0);
    }
  };

  return (
    <div className={`transition-all duration-300 ${isExpanded ? 'fixed inset-4 z-50 bg-white rounded-lg shadow-2xl border' : ''}`}>
      {isExpanded && (
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900 flex items-center">
            <Type className="w-5 h-5 mr-2" />
            Speaker Notes
          </h3>
          <button
            onClick={() => setIsExpanded(false)}
            className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <Minimize2 className="w-5 h-5" />
          </button>
        </div>
      )}
      
      <div className={isExpanded ? 'p-4 flex-1' : ''}>
        <div className="relative">
          <textarea
            ref={textareaRef}
            value={localNotes}
            onChange={(e) => handleNotesChange(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={placeholder}
            className={`
              w-full px-4 py-3 border border-gray-300 rounded-lg resize-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200
              ${isExpanded ? 'h-96' : 'h-24'}
            `}
          />
          
          {!isExpanded && (
            <button
              onClick={() => setIsExpanded(true)}
              className="absolute top-2 right-2 p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors"
              title="Expand Notes"
            >
              <Maximize2 className="w-4 h-4" />
            </button>
          )}
        </div>
        
        <div className="flex items-center justify-between mt-2 text-xs text-gray-500">
          <span>{localNotes.length} characters</span>
          <span>Use Tab for indentation</span>
        </div>
      </div>
    </div>
  );
};

export default SpeakerNotes;